import '../common/polyfill';

import {Component} from 'inferno'; // eslint-disable-line @typescript-eslint/no-unused-vars
import {Route, Switch} from 'inferno-router';

import {AuthDialog} from '../common/dialogs/AuthDialog';
import {ConfirmationDialog} from '../common/dialogs/ConfirmationDialog';
import {initConfig} from '../common/config';
import {BaseApp} from '../common/components/BaseApp';
import {HTTP404Page} from '../common/components/http404';
import {DialogContainer} from '../common/dialog';
import {getRouter, runIfInBrowser, setupAnalytics} from '../common/util';

import {KeyRegistrationPage, DevDashboardPage, DevActivationPage} from './pages/developer';
import {NavBar} from './components/NavBar';


import '~/assets/dist/iconfont/iconfont.css';
import '~/assets/fonts/fonts.css';
// import animate.css
import 'animate.css/source/_base.css';
import 'animate.css/source/sliding_entrances/slideInLeft.css';
import 'animate.css/source/sliding_entrances/slideInRight.css';
import 'animate.css/source/sliding_entrances/slideInUp.css';
import 'animate.css/source/sliding_exits/slideOutLeft.css';
import 'animate.css/source/sliding_exits/slideOutRight.css';
import 'animate.css/source/sliding_exits/slideOutDown.css';
import 'animate.css/source/fading_entrances/fadeInDown.css';
import 'animate.css/source/fading_exits/fadeOutUp.css';

import '~/assets/scss/bootstrap-replacer.scss';
import '~/assets/scss/ngDialog.min.css';
import '~/assets/scss/ngDialog-theme-default.min.css';
import '~/assets/scss/components/dialog.scss';
import './app.scss';


export const PATH = 'developer';

// TODO: consider making login/out work like admin page, when the form will
// show up on any page that requires login, rather than redirecting to a login
// page.


class App extends BaseApp {
    beforeChildren() {
        return [
            <NavBar key="navbar"/>,
        ];
    }
    afterChildren() {
        return (<DialogContainer
            dialogMap={{
                'auth-dialog': {
                    'class': AuthDialog,
                    'options': {
                        'page': 'developer',
                        'signupAllowed': true,
                    },
                },
                'confirmation-dialog': {
                    'class': ConfirmationDialog,
                    'options': {
                        'isBlockingDialog': true,
                    },
                    'style': {
                        'width': '440px',
                        'max-width': '100%',
                        'padding': '24px',
                    },
                },
            }}
        />);
    }
}


/**
 *
 * @param history
 * @param config
 * @param request
 * @param response
 * @param {jsx.AppGlobals} context
 */
export function routes(history, config, request, response, context) {
    const appGlobals = initConfig(config, PATH, request, response);
    Object.assign(context, appGlobals);
    setupAnalytics({context});

    const routes = <App appGlobals={appGlobals}><Switch>
        <Route path={`/${PATH}/keyregistration`}
            component={ KeyRegistrationPage }/>
        <Route path={`/${PATH}/dashboard`} component={ DevDashboardPage }/>
        <Route path={`/${PATH}/activate`} component={ DevActivationPage }/>
        <Route path={`/${PATH}*`} component={ HTTP404Page }/>
    </Switch></App>;
    return getRouter(routes, history);
}

// Render HTML if in the browser
runIfInBrowser(routes);
